export function isSameInstant(
  firstDateTime: string,
  secondDateTime: string,
): boolean {
  if (!firstDateTime || !secondDateTime) {
    return false;
  }

  const firstTimestamp = Date.parse(firstDateTime);
  const secondTimestamp = Date.parse(secondDateTime);

  return Number.isFinite(firstTimestamp) && firstTimestamp === secondTimestamp;
}
